import { CARD_FAILURE, CARD_SUCCESS, GET_CARDS, UPDATE_CARD } from "../actions/types";

const initialState = {
    // token: localStorage.getItem("token"),
    cards: null,
    loading: true,
    
  };


  export default function cards(state = initialState, action) {
    const { type, payload } = action;
    // console.log(payload);
    switch (type) {
      case GET_CARDS:
        return {
          ...state,
          cards: payload,
          loading: false,
         
        };
      case CARD_SUCCESS:
      case CARD_SUCCESS:
      case UPDATE_CARD:
        return { ...state, ...payload, isAuthenticated: true, loading: false };
      //  case LOGIN_FAIL:
    
      case CARD_FAILURE:
      
        return { ...state,  isAuthenticated: false, loading: false,  };
    
  
      default:
        return state;
    }
  }